<script setup lang="ts">
import { PropType, ref, watch } from "vue"

const props = defineProps({
  modelValue: { type: String, required: true },
  options: {
    type: Array as PropType<Array<{ label: string; value: string }>>,
    required: true,
  },
  label: { type: String, required: true },
  color: { type: String, default: "#7485A9" },
  toggleColor: { type: String, default: "primary" },
  labelColor: { type: String, default: "var(--va-primary)" },
  disabled: { type: Boolean, default: false },
})

const inputValue = ref(props.modelValue)
const emit = defineEmits(["update:modelValue"])

watch(
  () => props.modelValue,
  (v) => (inputValue.value = v),
)
watch(inputValue, (v) => emit("update:modelValue", v))
</script>

<template>
  <fieldset class="va-info-field-wrapper">
    <span :style="{ color: labelColor }" class="va-input-label">
      {{ label }}
    </span>

    <div class="flex">
      <VaButtonToggle
        v-model="inputValue"
        :options="options"
        :color="color"
        :toggle-color="toggleColor"
        gradient
        :disabled="props.disabled"
      />
    </div>
  </fieldset>
</template>
